import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "wechat-complaint-page"
};
import ActionModals from './components/ActionModals.vue';
import DetailDrawer from './components/DetailDrawer.vue';
import Filter from './components/Filter.vue';
import Overview from './components/Overview.vue';
import TableList from './components/TableList.vue';
import { usePage } from './hook/usePage';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      ui,
      columns,
      filterForm,
      loading,
      detailLoading,
      submitLoading,
      dataSource,
      total,
      pageNum,
      pageSize,
      selectedRows,
      selectedRowKeys,
      currentComplaint,
      overviewList,
      exportList,
      quickRanges,
      toMoney,
      replyTemplates,
      replyLoading,
      filterOptions,
      historyList,
      orderInfoList,
      refundReasons,
      refundDisabledTip,
      problemTypeMap,
      refundStateMap,
      complaintStateMap,
      search,
      reset,
      selectRows,
      handleOpenDetail,
      changePage,
      closeDetail,
      submitReply,
      submitResend,
      openRefund,
      submitRefund,
      submitReject,
      openBatch,
      submitBatch,
      batchTargetRows,
      batchRefundTotalAmount,
      copyValue
    } = usePage();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Overview, {
        "overview-list": _unref(overviewList)
      }, null, 8, ["overview-list"]), _createVNode(Filter, {
        modelValue: _unref(filterForm),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(filterForm) ? filterForm.value = $event : null),
        loading: _unref(loading),
        options: _unref(filterOptions),
        "quick-ranges": _unref(quickRanges),
        onSearch: _unref(search),
        onReset: _unref(reset)
      }, null, 8, ["modelValue", "loading", "options", "quick-ranges", "onSearch", "onReset"]), _createVNode(TableList, {
        rows: _unref(dataSource),
        loading: _unref(loading),
        total: _unref(total),
        "page-num": _unref(pageNum),
        "page-size": _unref(pageSize),
        columns: _unref(columns),
        "selected-rows": _unref(selectedRows),
        "selected-row-keys": _unref(selectedRowKeys),
        "table-height": _unref(ui).tableHeight.value,
        "refund-state-map": _unref(refundStateMap),
        "complaint-state-map": _unref(complaintStateMap),
        "to-money": _unref(toMoney),
        onSelect: _unref(selectRows),
        onOpenDetail: _unref(handleOpenDetail),
        onExport: _unref(exportList),
        onBatchChange: _unref(openBatch),
        onPageChange: _unref(changePage)
      }, null, 8, ["rows", "loading", "total", "page-num", "page-size", "columns", "selected-rows", "selected-row-keys", "table-height", "refund-state-map", "complaint-state-map", "to-money", "onSelect", "onOpenDetail", "onExport", "onBatchChange", "onPageChange"]), _createVNode(DetailDrawer, {
        "reply-content": _unref(ui).replyContent.value,
        "onUpdate:reply-content": _cache[1] || (_cache[1] = $event => _unref(ui).replyContent.value = $event),
        "reply-files": _unref(ui).replyFiles.value,
        open: _unref(ui).detailOpen.value,
        loading: _unref(detailLoading),
        complaint: _unref(currentComplaint),
        "history-list": _unref(historyList),
        "order-info-list": _unref(orderInfoList),
        "reply-templates": _unref(replyTemplates),
        "resend-text": _unref(ui).resendText.value,
        resending: _unref(ui).resending.value,
        "reply-loading": _unref(replyLoading),
        "submit-loading": _unref(submitLoading),
        "refund-disabled-tip": _unref(refundDisabledTip),
        "complaint-state-map": _unref(complaintStateMap),
        "refund-state-map": _unref(refundStateMap),
        "problem-type-map": _unref(problemTypeMap),
        "to-money": _unref(toMoney),
        "before-upload-image": _unref(ui).beforeUploadReplyImage,
        onClose: _unref(closeDetail),
        onReply: _unref(submitReply),
        onResend: _unref(submitResend),
        onRefund: _unref(openRefund),
        onReject: _unref(submitReject),
        onCopy: _unref(copyValue),
        onFillTemplate: _cache[2] || (_cache[2] = $event => _unref(ui).replyContent.value = $event),
        onPasteImage: _unref(ui).pasteImage,
        onRemoveFile: _unref(ui).removeReplyFile
      }, null, 8, ["reply-content", "reply-files", "open", "loading", "complaint", "history-list", "order-info-list", "reply-templates", "resend-text", "resending", "reply-loading", "submit-loading", "refund-disabled-tip", "complaint-state-map", "refund-state-map", "problem-type-map", "to-money", "before-upload-image", "onClose", "onReply", "onResend", "onRefund", "onReject", "onCopy", "onPasteImage", "onRemoveFile"]), _createVNode(ActionModals, {
        "refund-open": _unref(ui).refundOpen.value,
        "onUpdate:refund-open": _cache[3] || (_cache[3] = $event => _unref(ui).refundOpen.value = $event),
        "reject-open": _unref(ui).rejectOpen.value,
        "onUpdate:reject-open": _cache[4] || (_cache[4] = $event => _unref(ui).rejectOpen.value = $event),
        "batch-open": _unref(ui).batchOpen.value,
        "onUpdate:batch-open": _cache[5] || (_cache[5] = $event => _unref(ui).batchOpen.value = $event),
        "refund-amount": _unref(ui).refundAmount.value,
        "onUpdate:refund-amount": _cache[6] || (_cache[6] = $event => _unref(ui).refundAmount.value = $event),
        "refund-reason": _unref(ui).refundReason.value,
        "onUpdate:refund-reason": _cache[7] || (_cache[7] = $event => _unref(ui).refundReason.value = $event),
        "reject-reason": _unref(ui).rejectReason.value,
        "onUpdate:reject-reason": _cache[8] || (_cache[8] = $event => _unref(ui).rejectReason.value = $event),
        "batch-refund-mode": _unref(ui).batchRefundMode.value,
        "onUpdate:batch-refund-mode": _cache[9] || (_cache[9] = $event => _unref(ui).batchRefundMode.value = $event),
        "batch-refund-ratio": _unref(ui).batchRefundRatio.value,
        "onUpdate:batch-refund-ratio": _cache[10] || (_cache[10] = $event => _unref(ui).batchRefundRatio.value = $event),
        "batch-refund-reason": _unref(ui).batchRefundReason.value,
        "onUpdate:batch-refund-reason": _cache[11] || (_cache[11] = $event => _unref(ui).batchRefundReason.value = $event),
        "batch-reply-content": _unref(ui).batchReplyContent.value,
        "onUpdate:batch-reply-content": _cache[12] || (_cache[12] = $event => _unref(ui).batchReplyContent.value = $event),
        "batch-reply-files": _unref(ui).batchReplyFiles.value,
        "refund-screenshots": _unref(ui).refundScreenshots.value,
        "before-upload-refund-screenshot": _unref(ui).beforeUploadRefundScreenshot,
        "submit-loading": _unref(submitLoading),
        complaint: _unref(currentComplaint),
        "selected-count": _unref(batchTargetRows).length,
        "batch-total-amount": _unref(batchRefundTotalAmount),
        "batch-type": _unref(ui).batchType.value,
        "refund-reasons": _unref(refundReasons),
        "reply-templates": _unref(replyTemplates),
        "to-money": _unref(toMoney),
        "before-upload-image": _unref(ui).beforeUploadBatchReplyImage,
        onFillFullRefund: _cache[13] || (_cache[13] = $event => {
          var _unref2;
          return _unref(ui).refundAmount.value = Number(((_unref2 = _unref(currentComplaint)) === null || _unref2 === void 0 ? void 0 : _unref2.amount) || 0);
        }),
        onSubmitRefund: _unref(submitRefund),
        onSubmitReject: _unref(submitReject),
        onSubmitBatch: _unref(submitBatch),
        onPasteBatchReplyImage: _unref(ui).pasteBatchReplyImage,
        onRemoveFile: _unref(ui).removeBatchReplyFile,
        onPasteRefundScreenshot: _unref(ui).pasteRefundScreenshot,
        onRemoveRefundScreenshot: _unref(ui).removeRefundScreenshot
      }, null, 8, ["refund-open", "reject-open", "batch-open", "refund-amount", "refund-reason", "reject-reason", "batch-refund-mode", "batch-refund-ratio", "batch-refund-reason", "batch-reply-content", "batch-reply-files", "refund-screenshots", "before-upload-refund-screenshot", "submit-loading", "complaint", "selected-count", "batch-total-amount", "batch-type", "refund-reasons", "reply-templates", "to-money", "before-upload-image", "onSubmitRefund", "onSubmitReject", "onSubmitBatch", "onPasteBatchReplyImage", "onRemoveFile", "onPasteRefundScreenshot", "onRemoveRefundScreenshot"])]);
    };
  }
});